import { styled } from 'styled-components'
import { media } from '../../../../utils/styles'

export const Wrapper = styled.div`
  & .clb-side-menu {
    padding: var(--spacing-size-2xs) 0;
    height: calc(100vh - var(--header-height) - var(--spacing-size-2xs) * 2);
    gap: var(--spacing-size-3xs);
  }

  & .clb-side-menu-submenu {
    height: calc(100vh - var(--header-height));
  }

  & .clb-side-menu-item-label {
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    line-height: var(--line-height-xs);
  }

  ${media.smallMobile`
    & .clb-side-menu-submenu {
      width: calc(100dvw - var(--side-menu-width));
    }    

    & .clb-side-menu-submenu-header.open {
      transform: translateX(calc(100dvw - var(--side-menu-width) - 20px));
    }
  `}
`
